"use strict";
exports.__esModule = true;
var _1ds_core_js_1 = require("@microsoft/1ds-core-js");
exports.EventLatency = _1ds_core_js_1.EventLatency;
exports.EventPersistence = _1ds_core_js_1.EventPersistence;
exports.EventPropertyType = _1ds_core_js_1.EventPropertyType;
exports.ValueKind = _1ds_core_js_1.ValueKind;
var _1ds_cv_js_1 = require("@microsoft/1ds-cv-js");
exports.Cv = _1ds_cv_js_1.Cv;
var Constants_1 = require("./Constants");
exports.AUTOCOMPUTE_DURATION = Constants_1.AUTOCOMPUTE_DURATION;
var Types_1 = require("./Types");
exports.AppActionData = Types_1.AppActionData;
exports.AppLaunchData = Types_1.AppLaunchData;
exports.ContentUpdateData = Types_1.ContentUpdateData;
exports.EventKeyword = Types_1.EventKeyword;
exports.GtlAppLaunchType = Types_1.GtlAppLaunchType;
exports.GtlBehaviorType = Types_1.GtlBehaviorType;
exports.GtlDeviceInteractionVectorOptions = Types_1.GtlDeviceInteractionVectorOptions;
exports.GtlErrorProperties = Types_1.GtlErrorProperties;
exports.GtlEventType = Types_1.GtlEventType;
exports.GtlGroupIdType = Types_1.GtlGroupIdType;
exports.GtlPageType = Types_1.GtlPageType;
exports.GtlRegistrationOptions = Types_1.GtlRegistrationOptions;
exports.PageActionData = Types_1.PageActionData;
exports.PageContentData = Types_1.PageContentData;
exports.PageViewData = Types_1.PageViewData;
exports.PrivacyTag = Types_1.PrivacyTag;
var GamingTelemetry = require("./GamingTelemetry");
exports["default"] = GamingTelemetry;
//# sourceMappingURL=GamingTelemetryEntry.js.map